export { default } from 'object-assign'
